export enum PartExchangeStatuses {
  ACTIVE = 'active',
  BLOCKED = 'blocked',
  EXPIRED = 'expired',
}
